var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(!_vm.replaceimg)?_c('img',{staticClass:"pointer",attrs:{"src":require("@/assets/candidates/replace-blue.svg"),"alt":""},on:{"click":_vm.replaceThumbnail}}):_c('img',{class:{
			'opacity-img ': _vm.progress > 0 || _vm.uploadProgress > 0,
		},attrs:{"src":require("@/assets/asset-bank/listview/img-replace.svg"),"alt":""},on:{"click":_vm.handleProgressClick}}),_c('input',{ref:"replace",staticClass:"d-none pointer",attrs:{"type":"file","accept":_vm.fileTypes},on:{"change":_vm.fileSelected}})])
}
var staticRenderFns = []

export { render, staticRenderFns }